import { z } from "zod";
import {
  taskSignatureMetaSchema,
  taskSignatureWithEmailSchema,
} from "../../shared/signature.js";

export const vtSignatureConducteurSchema = taskSignatureMetaSchema;
export type VtSignatureConducteur = z.infer<typeof vtSignatureConducteurSchema>;

export const vtSignatureClientSchema = taskSignatureWithEmailSchema;
export type VtSignatureClient = z.infer<typeof vtSignatureClientSchema>;

export const vtSignaturesSchema = z
  .object({
    conducteur: vtSignatureConducteurSchema.optional(),
    client: vtSignatureClientSchema.optional(),
  })
  .partial();

export type VtSignatures = z.infer<typeof vtSignaturesSchema>;
